const gatewayFieldsExportMap = {
    'gateway.response.originalMessage': 'gatewayResponseOriginalMessage',
    'gateway.response.originalCode': 'gatewayResponseOriginalCode',
    'gateway.response.message': 'gatewayResponseMessage',
    'gateway.response.code': 'gatewayResponseCode',
    'gateway.avsResponse.message': 'avsGatewayResponseOriginalMessage',
    'gateway.avsResponse.code': 'avsGatewayResponseOriginalCode',
    'gateway.avsResponse.originalMessage': 'avsGatewayResponseOriginalMessage',
    'gateway.avsResponse.originalCode': 'avsGatewayResponseOriginalCode',
    'gateway.cvvResponse.message': 'cvvGatewayResponseOriginalMessage',
    'gateway.cvvResponse.code': 'cvvGatewayResponseOriginalCode',
    'gateway.cvvResponse.originalMessage': 'cvvGatewayResponseOriginalMessage',
    'gateway.cvvResponse.originalCode': 'cvvGatewayResponseOriginalCode',
    'dcc.base.amount': 'baseAmount',
    'dcc.base.currency': 'baseCurrency',
    'dcc.quote.amount': 'quoteAmount',
    'dcc.quote.currency': 'quoteCurrency',
    'dcc.outcome': 'dccOutcome',
    'dcc.usdMarkup': 'dccUsdMarkup',
};

export default gatewayFieldsExportMap;
